var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUAlertCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    fill: "#50AC32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4735 8.80667C16.4115 8.74418 16.3378 8.69458 16.2565 8.66074C16.1753 8.62689 16.0881 8.60947 16.0001 8.60947C15.9121 8.60947 15.825 8.62689 15.7437 8.66074C15.6625 8.69458 15.5888 8.74418 15.5268 8.80667L10.5601 13.78L8.47346 11.6867C8.40911 11.6245 8.33315 11.5756 8.24992 11.5428C8.16668 11.51 8.0778 11.4939 7.98834 11.4955C7.89889 11.497 7.81062 11.5162 7.72857 11.5518C7.64651 11.5875 7.57229 11.639 7.51013 11.7033C7.44797 11.7677 7.39909 11.8436 7.36629 11.9269C7.33349 12.0101 7.3174 12.099 7.31895 12.1885C7.3205 12.2779 7.33965 12.3662 7.37531 12.4482C7.41097 12.5303 7.46245 12.6045 7.5268 12.6667L10.0868 15.2267C10.1488 15.2892 10.2225 15.3387 10.3037 15.3726C10.385 15.4064 10.4721 15.4239 10.5601 15.4239C10.6481 15.4239 10.7353 15.4064 10.8165 15.3726C10.8978 15.3387 10.9715 15.2892 11.0335 15.2267L16.4735 9.78667C16.5411 9.72424 16.5951 9.64847 16.6321 9.56414C16.669 9.4798 16.6881 9.38873 16.6881 9.29667C16.6881 9.2046 16.669 9.11353 16.6321 9.02919C16.5951 8.94486 16.5411 8.86909 16.4735 8.80667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUAlertCheck);
export default __webpack_public_path__ + "static/media/u_alert-check.cf0d8f01.svg";
export { ForwardRef as ReactComponent };